import React from 'react';
import './Services.css';

const Services = ({ handleLoginClick }) => {
  return (
    <section className="services-section">
      <div className="services-hero">
        <img 
          src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" 
          alt="Professional business meeting and account management" 
          className="services-bg-image" 
        />
        <div className="services-overlay">
          <div className="services-content">
            <h2>My Account</h2>
            
            <div className="account-portals">
              <div className="portal-card">
                <h3>Customer Portal</h3>
              <div className="portal-form">
                <button className="btn btn-primary" onClick={handleLoginClick}>Log In</button>
                <p>Don't have an account? <button className="link-button" onClick={handleLoginClick}>Sign Up</button></p>
              </div>
            </div>
            
            <div className="portal-card">
                <h3>Business Portal</h3>
              <div className="portal-form">
                <button className="btn btn-primary" onClick={handleLoginClick}>Log In</button>
                <p>Don't have an account? <button className="link-button" onClick={handleLoginClick}>Sign Up</button></p>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;